import React, { Component } from "react";
import DataTable from "react-data-table-component";
import StepWizard from "react-step-wizard";
//// componentes reutilizables
import Titulo from "../../../generico/TituloPagina";
import Paso1 from "../interentidades/TransferenciaInterentidadPaso1";
import Paso2 from "../interentidades/TransferenciaInterentidadPaso2";
import Paso4 from "../interentidades/TransferenciaInterentidadPaso4";
import Paso3 from "../interentidades/TransferenciaInterentidadPaso3";
import Paso5 from "../interentidades/TransferenciaInterentidadPaso5";
// import Entrust from "../interentidades/TransferenciasInterentidadesEntrust";

export default class TransferenciaInterentidad extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
    this.paso4 = React.createRef();
    this.paso5 = React.createRef();
    // this.Entrust = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentaOrigen: {},
    cuentaDestino: {},
    importe: 0,
    nroOperacion: 0,
    intermediario: "",
    muestraPantallaEntrust:false
  });
  returnDataPaso1(_cuentaOrigen, _cuentaDestino) {
    this.setState({
      cuentaOrigen: _cuentaOrigen,
      cuentaDestino: _cuentaDestino[0],
    });
  }
  returnDataPaso2(_importe, _motivo, _codigo_otp,_muestraPantallaEntrust) {
    this.setState({
      importe: _importe,
      motivo: _motivo,
      codigootp: _codigo_otp,
      muestraPantallaEntrust : _muestraPantallaEntrust,
      
    });
    this.paso3.current.startCountdown();
  }
  returnDataPaso3(_codigo) {
    this.setState({
      codigo: _codigo
    });
 
  }

  returnDataPaso4(_nroOperacion, _intermediario) {
    this.setState({
      nroOperacion: _nroOperacion,
      intermediario: _intermediario
    });
  }
  returnDataPaso5() {
    this.state = this.getInitialState();
    this.initDataChildren();
  }
  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
    this.paso3.current.resetState();
    this.paso4.current.resetState();
    
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkCuentaDestino();
    }
  };
  
  componentDidMount() { }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="A otras Entidades" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{ zIndex: 0 }}>
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        // cuentaOrigen={this.state.cuentaOrigen}
                        // cuentaDestino={this.state.cuentaDestino}
                        // motivo={this.state.motivo}
                        // importe={this.state.importe}
                        codigootp={this.state.codigootp}
                        muestraPantallaEntrust = {this.state.muestraPantallaEntrust}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                      <Paso4
                        ref={this.paso4}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        motivo={this.state.motivo}
                        importe={this.state.importe}
                        
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      />
                      {/* <Entrust
                        ref={this.Entrust}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        motivo={this.state.motivo}
                        importe={this.state.importe}
                        
                        returnDataPaso4={this.returnDataPaso4.bind(this)}
                      /> */}
                      <Paso5
                        ref={this.paso5}
                        importe={this.state.importe}
                        nroOperacion={this.state.nroOperacion}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        intermediario={this.state.intermediario}
                        motivo={this.state.motivo}
                        
                        returnDataPaso5={this.returnDataPaso5.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
